import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import type { WorkspaceDataSource } from 'honeygrid-types'

export const dataSourcesQueryKey = (workspaceId?: string) => [
	'workspaces',
	workspaceId,
	'data-sources',
]

export const useDataSources = (workspaceId?: string) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<WorkspaceDataSource[]>({
		enabled: !!workspaceId,
		queryKey: dataSourcesQueryKey(workspaceId),
		queryFn: () => authFetch(`workspaces/${workspaceId}/data-sources`),
	})
}
